import constants from '@/config/constants.js'

const validModi = [
  {
    name: constants.LIST_MODUS.LIST,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER,
  },
  {
    name: constants.LIST_MODUS.PRINT,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER,
  },
  {
    name: constants.LIST_MODUS.EXPORT,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER,
  },
  {
    name: constants.LIST_MODUS.UPDATE,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER,
  },
  {
    name: constants.LIST_MODUS.TRASH,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER_MODUS_TRASH,
  },
  {
    name: constants.LIST_MODUS.APPROVAL,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER_MODUS_APPROVAL,
  },
  {
    name: constants.LIST_MODUS.MULTI_ACTION,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER,
  },
  {
    name: constants.LIST_MODUS.MULTI_ACTION_EDIT,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER,
  },
  {
    name: constants.LIST_MODUS.MAILER,
    filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER_MODUS_MAILER,
  },
]

export default {
  namespaced: true,

  state: () => {
    return {
      modus: constants.LIST_MODUS.LIST,
      filterStoreName: constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER,
    }
  },

  mutations: {
    SET_MODUS (state, modus) {
      const matchedModusObject = validModi.find(m => m.name === modus)

      if (!matchedModusObject) {
        console.error(`${modus} is not a valid documentsListModus`)

        return
      }

      state.modus = matchedModusObject.name
      state.filterStoreName = matchedModusObject.filterStoreName
    },

    FULL_RESET (state) {
      state.modus = constants.LIST_MODUS.LIST
      state.filterStoreName = constants.FILTER_STORE_NAMES.DOCUMENTS_FILTER
    },
  },
}
